import { call, put, select } from 'redux-saga/effects'

import { getPaginationState } from 'selectors/paginate'

export function* fetchData(obj, apiFn, ...args) {
  yield put(obj.request())
  const { response, error } = yield call(apiFn, ...args)
  if (response) {
    yield put(obj.success(response, args))
  } else {
    yield put(obj.failure(error, args))
  }
}

export function* fetchEntity(entity, apiFn, id, ...args) {
  yield put(entity.request(id))
  const { response, error } = yield call(apiFn, id, ...args)
  if (response) {
    yield put(entity.success(id, response, args))
  } else {
    yield put(entity.failure(id, error, args))
  }
}

export function delay(millis) {
  return new Promise(resolve => {
    setTimeout(() => resolve(true), millis)
  })
}

export function* fetchPaginate(apiFn, paginationName, key, nextPage = false, ...args) {
  const paginationState = yield select(getPaginationState(paginationName, key))

  // Do nothing if we have already fetched the first page and there is no nextPageUrl or nextPage is not set
  if (paginationState && paginationState.pageCount > 0 && (!paginationState.nextPageUrl || !nextPage)) {
    return
  }

  yield call(apiFn, key, paginationState && paginationState.nextPageUrl, ...args)
}



/** WEBPACK FOOTER **
 ** ./src/utils/sagas/sagas.js
 **/